import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Layout: React.FC = () => {
  const { pathname } = useLocation();
  const hideFooter = pathname === '/requests' || pathname === '/success';

  return (
    <>
      <Header />
      <main style={{ minHeight: pathname === '/success' ? '0' : '80vh' }}>
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
    </>
  );
};

export default Layout;
